import React, { useEffect, useState, useContext, useLayoutEffect, useRef } from 'react';
import { Card, CardBody, CardHeader, Table, Row, Col, Badge, Button, Modal, ModalHeader, ModalBody, UncontrolledPopover, PopoverHeader, PopoverBody } from 'reactstrap';
import { Icon } from '@iconify/react';
import homeCity from '@iconify/icons-mdi/home-city';
import accountBox from '@iconify/icons-mdi/account-box';
import accountIcon from '@iconify/icons-mdi/account';
import pillIcon from '@iconify/icons-mdi/pill';
import currencyUsd from '@iconify/icons-mdi/currency-usd';
import calendarMonth from '@iconify/icons-mdi/calendar-month';
import cashIcon from '@iconify/icons-mdi/cash';
import clipboardCheck from '@iconify/icons-mdi/clipboard-check';
import printerIcon from '@iconify/icons-mdi/printer';
import Loader from '../components/Loader';
import { UserContext } from '../contexts/UserContext';
import SimpleBar from 'simplebar-react';
import cashLock from '@iconify/icons-mdi/cash-lock';
import { Switch, Route } from 'react-router-dom';
import { useHistory, useLocation } from 'react-router-dom';
import arrowTopRightBoldBoxOutline from '@iconify/icons-mdi/arrow-top-right-bold-box-outline';
import { SelectedFacilitiesContext } from '../contexts/SelectedFacilitiesContext';
import menuUpOutline from '@iconify/icons-mdi/menu-up-outline';
import menuDownOutline from '@iconify/icons-mdi/menu-down-outline';
import arrowDownThin from '@iconify/icons-mdi/arrow-down-thin';
import arrowUpThin from '@iconify/icons-mdi/arrow-up-thin';
import arrowsVertical from '@iconify/icons-carbon/arrows-vertical';
import pillOff from '@iconify/icons-mdi/pill-off';
import arrowUp from '@iconify/icons-carbon/arrow-up';
import arrowDown from '@iconify/icons-carbon/arrow-down';
import commentText from '@iconify/icons-mdi/comment-text';
import noteTextOutline from '@iconify/icons-mdi/note-text-outline';
import useMediprocityScript from '../custom-hooks/useMediprocityScript';
import useAlertsUserSettings from '../custom-hooks/useAlertsSortOrder';
import { Helmet } from 'react-helmet';
import TableRowDetailModal from './TableRowDetailModal';
// import { mockHighCostData } from '../mock-data/mockHighCostData';
import cloneDeep from 'lodash.clonedeep';
import classNames from 'classnames';
import hospitalBox from '@iconify/icons-mdi/hospital-box';
import { SrxApi } from '../api/SrxApi';
import { WidgetsData } from '../data/WidgetsData';
import refreshIcon from '@iconify/icons-mdi/refresh';
import { useAtom } from 'jotai';
import { ActiveAlertContext } from '../contexts/ActiveAlertContext';
import { CurrentTimeContext } from '../contexts/CurrentTimeContext';
import useRefreshAlerts from '../custom-hooks/useRefreshAlerts';
import { fetchWidgetAlertsWithDummyFallback } from '../utility-services/fetchWidgetAlertsWithDummyFallback';
import {
    highCostAtomUserSettings,
    highCostAlertsAtomUserSettings,
    clarificationsAtomUserSettings,
    priorAuthAtomUserSettings,
    nonCoveredAtomUserSettings,
    therapeuticIntAtomUserSettings,
    admissionMedsAtomUserSettings,
    refillTooSoonAtomUserSettings,
    pumpPickupAtomUserSettings,
    narcoticsRefillAtomUserSettings,
    alfNewScriptAtomUserSettings,
    alfCostResponseAtomUserSettings,
} from '../jotai-atoms/AlertAtoms';
import { ShowResolvedAlertsContext } from '../contexts/ShowResolvedAlertsContexts';
import { ShowAllFacilitiesContext } from '../contexts/ShowAllFacilitiesContext';
import { AlertSearchContext } from '../contexts/AlertSearchContext';
import AlertSearchBar from '../components/AlertSearchBar';
import { hasWidgetViewPermission } from '../utility-services/rolePermissions';

const AlertsDashboard = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { activeAlert, setActiveAlert } = useContext(ActiveAlertContext);
    const { user, roles } = useContext(UserContext);

    //  set alerts sort and show settings
    useAlertsUserSettings();

    const [highCostUserSettings, setHighCostUserSettings] = useAtom(highCostAtomUserSettings);
    const [highCostAlertsUserSettings, setHighCostAlertsUserSettings] = useAtom(highCostAlertsAtomUserSettings);
    const [nonCoveredUserSettings, setNonCoveredUserSettings] = useAtom(nonCoveredAtomUserSettings);
    const [clarificationsUserSettings, setClarificationsUserSettings] = useAtom(clarificationsAtomUserSettings);
    const [priorAuthUserSettings, setPriorAuthUserSettings] = useAtom(priorAuthAtomUserSettings);
    const [therapeuticIntUserSettings, setTherapeuticIntUserSettings] = useAtom(therapeuticIntAtomUserSettings);
    const [admissionMedsUserSettings, setAdmissionMedsUserSettings] = useAtom(admissionMedsAtomUserSettings);
    const [refillTooSoonUserSettings, setRefillTooSoonUserSettings] = useAtom(refillTooSoonAtomUserSettings);
    const [pumpPickupUserSettings, setpumpPickupUserSettings] = useAtom(pumpPickupAtomUserSettings);
    const [narcoticsRefillUserSettings, setNarcoticsRefillUserSettings] = useAtom(narcoticsRefillAtomUserSettings);
    const [alfNewScriptUserSettings, setAlfNewScriptUserSettings] = useAtom(alfNewScriptAtomUserSettings);
    const [alfCostResponseUserSettings, setAlfCostResponseUserSettings] = useAtom(alfCostResponseAtomUserSettings);

    const routerHistory = useHistory();
    const { searchValue, setSearchValue } = useContext(AlertSearchContext);

    useEffect(() => {
        if (activeAlert)
            setIsModalOpen(true);
        else
            setIsModalOpen(false);
    }, [activeAlert]);

    const toggleModal = () => {
        if (activeAlert)
            setActiveAlert(null);
        setIsModalOpen(!isModalOpen);
    };

    const { faciToken, setFaciToken } = useContext(UserContext);

    function statusPill(status) {
        if (status === 'pending') {
            return (<Badge className='bg-warning'>
                {status}
            </Badge>);
        } else if (status === 'approved') {
            return (<Badge className='bg-success'>
                {status}
            </Badge>);
        } else if (status === 'denied') {
            return (<Badge className='bg-danger'>
                {status}
            </Badge>);
        } else if (status === 'completed') {
            return (<Badge className='bg-info'>
                {status}
            </Badge>);
        }

        return (<Badge className='bg-info'>
            {status}
        </Badge>);
    }


    // console.log(WidgetsData);
    // const [numberOfAlertsToDisplay, setNumberOfAlertsToDisplay] = useState({
    //     highCostAlerts: 15
    // })

    // if(loading){
    //     return(
    //         <div className='page-loading-loader-div w-100 d-flex justify-content-center align-items-center'>
    //     <div>
    //     <h4>Loading alerts...</h4>
    //         <div className="bouncing-loader">
    //             <div></div>
    //             <div></div>
    //             <div></div>
    //         </div>
    //         </div>
    //     </div>
    //     )
    // }

    const alertsConfig = () => {
        WidgetsData.forEach((req) => {
            const getSortOrder = (alertName) => {
                switch (alertName) {
                    case 'highCost':
                        return { sortOrder: highCostUserSettings.sortOrder, hidden: highCostUserSettings.hidden };
                    case 'highcostalerts':
                        return { sortOrder: highCostAlertsUserSettings.sortOrder, hidden: highCostAlertsUserSettings.hidden };
                    case 'clarifications':
                        return { sortOrder: clarificationsUserSettings.sortOrder, hidden: clarificationsUserSettings.hidden };
                    case 'priorAuth':
                        return { sortOrder: priorAuthUserSettings.sortOrder, hidden: priorAuthUserSettings.hidden };
                    case 'nonCovered':
                        return { sortOrder: nonCoveredUserSettings.sortOrder, hidden: nonCoveredUserSettings.hidden };
                    case 'therapeuticInt':
                        return { sortOrder: therapeuticIntUserSettings.sortOrder, hidden: therapeuticIntUserSettings.hidden };
                    case 'admissionMeds':
                        return { sortOrder: admissionMedsUserSettings.sortOrder, hidden: admissionMedsUserSettings.hidden };
                    case 'refillTooSoon':
                        return { sortOrder: refillTooSoonUserSettings.sortOrder, hidden: refillTooSoonUserSettings.hidden };
                    case 'pumpPickup':
                        return { sortOrder: pumpPickupUserSettings.sortOrder, hidden: pumpPickupUserSettings.hidden };
                    case 'narcoticsRefill':
                        return { sortOrder: narcoticsRefillUserSettings.sortOrder, hidden: narcoticsRefillUserSettings.hidden };
                    case 'alfNewScript':
                        return { sortOrder: alfNewScriptUserSettings.sortOrder, hidden: alfNewScriptUserSettings.hidden };
                    case 'alfCostResponse':
                        return { sortOrder: alfCostResponseUserSettings.sortOrder, hidden: alfCostResponseUserSettings.hidden };
                    default:
                        break;
                }
            };
            let sortandHide = getSortOrder(req.category);
            WidgetsData[WidgetsData.findIndex(i => i.category === req.category)] = { ...req, ...sortandHide };
        });
    };

    useEffect(() => {
        alertsConfig();
    }, []);

    if (WidgetsData.length === 0 || WidgetsData.every(w => w.hidden || !hasWidgetViewPermission(roles, w.requestActionPermissionWidgetName))) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '85vh' }}>
                <h3 className='text-muted' style={{ fontSize: '20px' }}>No widgets</h3>
            </div>
        );
    }

    const isNewAlertType = (category) => [
        'refillTooSoon',
        'pumpPickup',
        'narcoticsRefill',
        'clarifications',
        'priorAuth',
        'highCost',
        'nonCovered',
        'therapeuticInt',
        'admissionMeds',
        'highcostalerts',
        'alfNewScript',
        'alfCostResponse',
        'unavailableMedicationAlerts',
    ].includes(category);

    return (
        <>
            <Row className='mt-3'>
                <Col>
                    <AlertSearchBar
                        label="Search"
                        searchPlaceholder="rx no, patient name, drug name"
                        value={searchValue}
                        onSearch={(value) => setSearchValue((value || '').trim())}
                    />
                </Col>
            </Row>
            {/* <Row>
                <Col>
                    <h2>Pharmacy Alerts</h2>
                </Col>
            </Row> */}
            <Row className='justify-content-between mt-3'>
                {WidgetsData.filter(w => !w.hidden && hasWidgetViewPermission(roles, w.requestActionPermissionWidgetName)).sort((a, b) => a.sortOrder < b.sortOrder ? -1 : 1).map((item, index) => (
                    <Col key={item.category} xl={6}>
                        {
                            isNewAlertType(item.category) ? <AlertWidgetV2 hidden={item.hidden} key={item.category} item={item} setActiveAlert={setActiveAlert} searchValue={searchValue} /> :
                                <AlertWidget hidden={item.hidden} key={item.category} item={item} setActiveAlert={setActiveAlert} setFaciToken={setFaciToken} />
                        }
                    </Col>
                ))}
                {activeAlert && <TableRowDetailModal isOpen={isModalOpen} toggle={toggleModal} alertInfo={activeAlert} />}
                {/* <Switch>
                    <Route path='/dashboard/:alertModal'  
                        component={(props) => (
                                <AlertWidgetLargeModal />
                                )}>
                    </Route>
                </Switch> */}
            </Row>
        </>
    );
};

const AlertWidget = ({ item, setActiveAlert, setFaciToken, hidden }) => {

    const { selectedFacilities } = useContext(SelectedFacilitiesContext);

    const [data, setData] = useAtom(item.atom);

    const [filteredAlerts, setFilteredAlerts] = useAtom(item.atomFilteredAlerts);

    const routerHistory = useHistory();

    // useEffect(() => {
    //     getData()
    // }, [])


    ///////!!!!!!!!!!!!!!!!!!!FAKE DATA

    // useEffect(() => {

    //     async function getData(){
    //         try{
    //             if(!item.hasOwnProperty('path'))
    //                 return
    //             const {data} = await SrxApi.get(`/${item.path}`)
    //             setAlerts(data[item.stateName])
    //             console.log(data[item.stateName])
    //         } catch(err){
    //             if(err.response?.status === 401){
    //                 localStorage.removeItem('FACI_TOKEN');
    //                 setFaciToken(null);
    //                 history.replace('/account/login')
    //             } else {
    //                 console.log(err)
    //             }
    //         } finally {
    //             setLoading(false)
    //         }
    //     }

    //     getData()

    // }, [])

    // const [onlyCallOnce, setOnlyCallOnce] = useState(false)

    // useEffect(() => {
    //     if(alerts.length && !onlyCallOnce){
    //         setOnlyCallOnce(true)
    //     setTimeout(() => filterNewAlerts(mockHighCostData), 20000)
    //     refreshDataTimerRef.current = setTimeout(() => {
    //         setAlerts(alerts.filter(alert => alert.displayStatus !== 'deleted'))
    //     }, 11 * 1000)
    //     }
    // }, [alerts])

    ///////!!!!!!!!!!!!!!!!!!! END OF FAKE DATA

    const [sortBy, setSortBy] = useState({
        sortField: item.defaultSortField,
        sortDirection: 'asc'
    });

    // const [filterByFacility(alerts), setFilteredByFacilityAlerts] = useState([])

    // useEffect(() => {
    //     setFilteredByFacilityAlerts(filterByFacility(alerts))
    // }, [selectedFacilities, alerts])
    function sortByField(array) {
        switch (sortBy.sortField) {
            case 'dispenseDt':
                if (sortBy.sortDirection === 'asc') {
                    return array.sort((a, b) => a._generatedID > b._generatedID ? -1 : 1).sort((a, b) => new Date(a.dispenseDt) > new Date(b.dispenseDt) ? -1 : 1);
                }
                else {
                    return array.sort((a, b) => a._generatedID > b._generatedID ? -1 : 1).sort((a, b) => new Date(a.dispenseDt) < new Date(b.dispenseDt) ? -1 : 1);
                }
            case 'patName':
                if (sortBy.sortDirection === 'asc')
                    return array.sort((a, b) => a.patName < b.patName ? -1 : 1);
                else
                    return array.sort((a, b) => a.patName > b.patName ? -1 : 1);
            case 'facName':
                if (sortBy.sortDirection === 'asc')
                    return array.sort((a, b) => a.facName < b.facName ? -1 : 1);
                else
                    return array.sort((a, b) => a.facName > b.facName ? -1 : 1);
            case 'facID':
                if (sortBy.sortDirection === 'asc')
                    return array.sort((a, b) => a.facID < b.facID ? -1 : 1);
                else
                    return array.sort((a, b) => a.facID > b.facID ? -1 : 1);
            case 'drugLabelName':
                if (sortBy.sortDirection === 'asc')
                    return array.sort((a, b) => a.drugLabelName < b.drugLabelName ? -1 : 1);
                else
                    return array.sort((a, b) => a.drugLabelName > b.drugLabelName ? -1 : 1);
            case 'prescribedDrugName':
                if (sortBy.sortDirection === 'asc')
                    return array.sort((a, b) => a.prescribedDrugName < b.prescribedDrugName ? -1 : 1);
                else
                    return array.sort((a, b) => a.prescribedDrugName > b.prescribedDrugName ? -1 : 1);
            case 'ttlPrice':
                if (sortBy.sortDirection === 'asc')
                    return array.sort((a, b) => a.ttlPrice < b.ttlPrice ? -1 : 1);
                else
                    return array.sort((a, b) => a.ttlPrice > b.ttlPrice ? -1 : 1);
            case 'admDate':
                if (sortBy.sortDirection === 'asc')
                    return array.sort((a, b) => a._generatedID > b._generatedID ? -1 : 1).sort((a, b) => new Date(a.admDate) > new Date(b.admDate) ? -1 : 1);
                else
                    return array.sort((a, b) => a._generatedID > b._generatedID ? -1 : 1).sort((a, b) => new Date(a.admDate) < new Date(b.admDate) ? -1 : 1);
            case 'dateCreated':
                if (sortBy.sortDirection === 'asc')
                    return array.sort((a, b) => a._generatedID > b._generatedID ? -1 : 1).sort((a, b) => new Date(a.dateCreated) > new Date(b.dateCreated) ? -1 : 1);
                else
                    return array.sort((a, b) => a._generatedID > b._generatedID ? -1 : 1).sort((a, b) => new Date(a.dateCreated) < new Date(b.dateCreated) ? -1 : 1);
            case 'alertCreatedOn':
                if (sortBy.sortDirection === 'asc')
                    return array.sort((a, b) => a._generatedID > b._generatedID ? -1 : 1).sort((a, b) => new Date(a.alertCreatedOn) > new Date(b.alertCreatedOn) ? -1 : 1);
                else
                    return array.sort((a, b) => a._generatedID > b._generatedID ? -1 : 1).sort((a, b) => new Date(a.alertCreatedOn) < new Date(b.alertCreatedOn) ? -1 : 1);
            default:
                return array;
        }
    }

    const defaultNumOfAlerts = 100;

    const [numOfShownAlerts, setNumOfShownAlerts] = useState(defaultNumOfAlerts);

    const numOfAdditionalAlerts = () => {
        const total = (filteredAlerts?.length) || 0;
        if ((total - numOfShownAlerts) >= defaultNumOfAlerts) {
            return defaultNumOfAlerts;
        } else if ((total > defaultNumOfAlerts) && (total - numOfShownAlerts) < defaultNumOfAlerts) {
            return total - numOfShownAlerts;
        } else {
            return 0;
        }
    };

    function add100Rows() {
        setNumOfShownAlerts(numOfShownAlerts + numOfAdditionalAlerts());
    }

    function getDate(date) {
        let onlyDate = new Date(date).toLocaleDateString();
        return onlyDate;
    }

    const SortCarets = () => (
        <>
            {sortBy.sortDirection === 'asc' ?
                <Icon icon={arrowUp} color="black" />
                :
                <Icon icon={arrowDown} color="black" />
            }
        </>
    );

    function onClickSort(field) {
        if (field === sortBy.sortField) {
            setSortBy({
                ...sortBy,
                sortDirection: sortBy.sortDirection === 'asc' ? 'desc' : 'asc'
            });
        } else {
            setSortBy({
                sortField: field,
                sortDirection: 'asc'
            });
        }
    }

    // const [currentTime, setCurrentTime] = useState(Date.now())

    // useEffect(() => {
    //     let interval = setInterval(() => setCurrentTime(Date.now), 1 * 1000)
    //     return () => clearInterval(interval)
    // }, [])

    const { currentTime } = useContext(CurrentTimeContext);

    function displayDifferenceInMinutes(rfrshTime) {
        let differenceInMinutes = Math.floor((new Date(currentTime).getTime() - new Date(rfrshTime).getTime()) / 60000);

        if (differenceInMinutes < 1)
            return {
                minutes: differenceInMinutes,
                view: <small>Less than <span style={{ fontSize: '16px' }} ><b>1</b></span> minute ago</small>
            };
        else if (differenceInMinutes === 1)
            return {
                minutes: differenceInMinutes,
                view: <small><span style={{ fontSize: '16px' }}><b>{differenceInMinutes}</b></span> minute ago</small>
            };
        else if (differenceInMinutes >= 2 && differenceInMinutes <= 60)
            return {
                minutes: differenceInMinutes,
                view: <small><span style={{ fontSize: '16px' }}><b>{differenceInMinutes}</b></span> minutes ago</small>
            };
        else
            return {
                minutes: differenceInMinutes,
                view: <small>More than <span style={{ fontSize: '16px' }} ><b>1</b></span> hour ago</small>
            };
    }

    let differenceInMinutes = displayDifferenceInMinutes(data?.lastRefreshed);

    const { refreshWidget } = useRefreshAlerts();

    return (
        <Card hidden={hidden} style={{
            borderRadius: '11px', minHeight: '446.61px',
            opacity: !item.active ? '.30' : '',
            pointerEvents: !item.active ? 'none' : ''
        }}
        >
            <CardHeader
                className='d-flex align-items-center justify-content-center bg-primary text-white position-relative gradient-modal'
                style={{
                    borderTopLeftRadius: '11px', borderTopRightRadius: '11px',
                    background: "linear-gradient(90deg, #452f69 0%, #452f69 50%, #000 90%)"
                }}
            >
                <div className='position-relative' style={{ maxWidth: 'max-content' }}>
                    <strong>{item.name.toLocaleUpperCase()}</strong>
                    {item.active && <Badge className="position-absolute ml-1 d-flex justify-content-center align-items-center bg-danger
                                    print-all-badge"
                    >
                        {filteredAlerts?.length || 0}
                    </Badge>}
                </div>
                {data?.lastRefreshed && <div className='position-absolute' style={{ left: '20px' }}>
                    <span className='elementToFadeInAndOut'><small>Updated</small></span>: {differenceInMinutes.view}
                </div>}
                <Button color="link" className='link-button p-0 d-flex align-items-center position-absolute hover-only refresh-widget-button-rotate'
                    style={{ right: '50px', color: 'white' }}
                    onClick={() => {
                        refreshWidget(item.path);
                    }}
                    title="Refresh Alerts"
                >
                    <Icon icon={refreshIcon} width="25" />
                </Button>
                <Button color="link" className='link-button p-0 d-flex align-items-center position-absolute hover-only'
                    style={{ right: '20px', color: 'white' }}
                    onClick={() => routerHistory.push('/alerts/' + item.path)}
                    title="Open Widget"
                >
                    <Icon icon={arrowTopRightBoldBoxOutline} width="25" />
                </Button>
            </CardHeader>
            {data?.loading ?
                <div className='page-loading-loader-div w-100 d-flex justify-content-center align-items-center'>
                    <div>
                        {/* <h4>Loading alerts...</h4> */}
                        <div className="bouncing-loader">
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                </div>
                :
                <SimpleBar style={{ maxHeight: '400px' }}>
                    <CardBody className='pb-1 px-1 pt-0'>
                        <Table hover size='sm' className='mb-0'>
                            <thead style={{ position: 'sticky', top: '0', backgroundColor: 'white' }}>
                                <tr style={{ fontSize: '14px', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                                    {item.columns.map((col, index) => (
                                        <th key={index} className={`py-0 position-relative ${col.sort ? '' : 'noHover'}`} onClick={col.sort ? () => onClickSort(col.key) : null}
                                        >
                                            {col.icon && <Icon icon={col.icon} />} {col.name} {col.sort ? (sortBy.sortField === col.key) ? <SortCarets /> : <Icon icon={arrowsVertical} style={{ opacity: '0.6' }} /> : ''}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {(filteredAlerts?.length || 0) > 0 ?
                                    <>
                                        {sortByField(filteredAlerts || []).slice(0, numOfShownAlerts).map((alert, index) =>
                                        (
                                            <tr key={index} style={{ fontSize: '13px' }}
                                                className={classNames(
                                                    { unreadRow: !alert.readByFaci },
                                                    { readRow: alert.readByFaci },
                                                    { resolvedRow: alert.srxStatus || alert.pharmacyStatus },
                                                    { newRow: alert.displayStatus === 'new' },
                                                    { oldRow: alert.displayStatus === 'old' },
                                                    { deletedRow: alert.displayStatus === 'deleted' },
                                                    { approvedRow: alert.displayStatus === 'approved' },
                                                    { approvedOnceRow: alert.displayStatus === 'approvedOnce' },
                                                    { deniedRow: alert.displayStatus === 'denied' },
                                                    { askedRow: alert.displayStatus === 'asked' },
                                                    { sendRow: alert.displayStatus?.toLowerCase() === 'send' },
                                                    { doNotSendRow: alert.displayStatus?.toLowerCase() === 'donotsend' }
                                                )}
                                                onClick={() => {
                                                    setActiveAlert({
                                                        name: item.name,
                                                        alert: alert,
                                                        stateName: item.stateName,
                                                        category: item.category,
                                                        requestActionPermissionWidgetName: item.requestActionPermissionWidgetName
                                                    });
                                                }}
                                            >
                                                {item.columns.map((col, index) => (
                                                    <td key={index} style={{ verticalAlign: 'middle' }} className={col?.className}>{col.prefix}{col.format ? col.format(alert[col.key], alert.rxGuid, alert) : alert[col.key]}{col.suffix}</td>
                                                ))}
                                                {/* <td style={{ verticalAlign: 'middle' }}>{alert.patName}</td>
                                                <td style={{ verticalAlign: 'middle' }}>{alert.facName}</td>
                                                <td style={{ verticalAlign: 'middle' }}>{alert.drugLabelName}</td>
                                                <td style={{ verticalAlign: 'middle' }}>${alert.ttlPrice}</td> */}
                                                {/* <td>{statusPill(alert.status)}</td> */}
                                                {/* <td style={{ verticalAlign: 'middle' }}>${alert.priceCap}</td>
                                                <td style={{ verticalAlign: 'middle' }}>{getDate(alert.dispenseDt)}</td> */}
                                            </tr>
                                        ))}
                                        <tr>
                                            <td colSpan="100%" align="center">
                                                {(filteredAlerts?.length || 0) ?
                                                    numOfAdditionalAlerts() > 0 ? <Button color="link"
                                                        onClick={() => add100Rows(item.stateName)}>
                                                        <b>Show {numOfAdditionalAlerts()} more...</b>
                                                    </Button>
                                                        :
                                                        <span><b>End of alerts</b></span>
                                                    :
                                                    <span><b>No alerts</b></span>
                                                }
                                            </td>
                                        </tr>
                                    </>
                                    :
                                    <tr>
                                        <td colSpan="6" align="center" style={{ fontSize: '30px', backgroundColor: 'white' }}>
                                            {/* <b>Coming Soon</b> */}
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </Table>
                    </CardBody>
                </SimpleBar>
            }
            {/* <Badge className="position-absolute ml-1 d-flex justify-content-center align-items-center bg-danger
                            print-all-badge"
                            >
                                { item.stateName === 'highCostAlerts'  && highCostAlerts.length }
                            </Badge> */}
        </Card>
    );
};

const AlertWidgetV2 = ({ hidden, item, setActiveAlert, searchValue }) => {
    const [pharmacyAlert, setPharmacyAlert] = useAtom(item.atom);

    const { selectedFacilities } = useContext(SelectedFacilitiesContext);
    const { currentTime } = useContext(CurrentTimeContext);
    const { showResolved, setShowResolved } = useContext(ShowResolvedAlertsContext);
    const { showAllFacilities } = useContext(ShowAllFacilitiesContext);

    const routerHistory = useHistory()

    useEffect(() => {
        setReactSucksHook(!reactSucksHook);

        loadAlertsOnFilter();
    }, [selectedFacilities, showResolved, showAllFacilities, searchValue]);

    const [sortBy, setSortBy] = useState({
        sortField: item.defaultSortField,
        sortDirection: 'desc'
    });

    const [reactSucksHook, setReactSucksHook] = useState(false);

    useEffect(() => {
        const intervalId = setInterval(refreshData, 30000);

        return () => clearInterval(intervalId); // Cleanup on unmount or dependency change
    }, [reactSucksHook, searchValue]);

    const SortCarets = () => (
        <>
            {sortBy.sortDirection === 'asc' ?
                <Icon icon={arrowUp} color="black" />
                :
                <Icon icon={arrowDown} color="black" />
            }
        </>
    );

    const onClickSort = (field) => {
        let direction = 'asc';

        if (field === sortBy.sortField) {
            direction = sortBy.sortDirection === 'asc' ? 'desc' : 'asc';
        }

        setPharmacyAlert((currentPharmacyAlert) => ({
            ...currentPharmacyAlert,
            isSorted: true,
        }));

        setSortBy({
            sortField: field,
            sortDirection: direction
        });

        setReactSucksHook(!reactSucksHook);

        loadAlertsOnSort(field, direction);
    }

    const defaultNumOfAlerts = 100;

    const [numOfShownAlerts, setNumOfShownAlerts] = useState(defaultNumOfAlerts);

    const numOfAdditionalAlerts = () => {
        if ((pharmacyAlert.alertData.length - numOfShownAlerts) >= defaultNumOfAlerts) {
            return defaultNumOfAlerts;
        } else if ((pharmacyAlert.length > defaultNumOfAlerts) && (pharmacyAlert.length - numOfShownAlerts) < defaultNumOfAlerts) {
            return pharmacyAlert.length - numOfShownAlerts;
        } else {
            return 0;
        }
    };

    const alertsUrl = (more = false) => {
        const params = [];

        if (pharmacyAlert.isSorted) {
            params.push(`sort=${sortBy.sortField}`, `sortOrder=${sortBy.sortDirection}`);
            if (more) params.push(`page=${pharmacyAlert.nextPage}`);
        } else if (more) {
            // Use cursor pagination only if the widget supports it
            if (item.usesCursorPaging !== false) {
                params.push(`cursor=${pharmacyAlert.cursor}`);
            } else {
                params.push(`page=${pharmacyAlert.nextPage}`);
            }
        }

        // IF facilities is not null add the facilities to the query parameter, a new query parameter will be added for each facility not separated by commas
        if (selectedFacilities) {
            selectedFacilities.forEach((facility) => {
                params.push(`facilityIds=${facility.facID}`);
            });
        }

        if (showResolved) {
            params.push('hideResolved=false');
        }

        if (showAllFacilities) {
            params.push('showAll=true');
        }

        if (searchValue) {
            params.push(`searchValue=${encodeURIComponent(searchValue)}`);
        }

        return params.length ? `${item.path}?${params.join('&')}` : item.path;
    };

    function add100Rows() {
        setNumOfShownAlerts(numOfShownAlerts + numOfAdditionalAlerts());
    }

    const loadData = async (more = true) => {
        const data = item.dummyData
            ? await fetchWidgetAlertsWithDummyFallback(alertsUrl(more), item.dummyData)
            : (await SrxApi.get(alertsUrl(more))).data;

        const newData = more ? [...pharmacyAlert.alertData, ...data.results] : data.results;

        setPharmacyAlert((currentPharmacyAlert) => ({
            ...currentPharmacyAlert,
            alertData: newData,
            cursor: data.cursor,
            lastRefreshed: data.timeStamp,
            loading: false,
            error: false,
            alertCount: currentPharmacyAlert.alertCount,
            filteredCount: data.count,
            nextPage: data.nextPage,
            isSorted: currentPharmacyAlert.isSorted,
        }));

        add100Rows();
    }

    const refreshData = async () => {
        const _url = new URL(window.location.origin + '/' + alertsUrl());

        _url.searchParams.delete('page');

        _url.searchParams.delete('cursor');

        let data = item.dummyData
            ? await fetchWidgetAlertsWithDummyFallback(_url.pathname + _url.search, item.dummyData)
            : (await SrxApi.get(_url.pathname + _url.search)).data;

        setPharmacyAlert((currentPharmacyAlert) => {
            // Extract the top {data.length} alerts from CURRENT pharmacyAlert data (not stale closure)
            const topAlerts = currentPharmacyAlert.alertData.slice(0, data.results.length);

            const newData = data.results.filter((alert) => alert.rxGuid && !topAlerts.some((oldAlert) => oldAlert.rxGuid === alert.rxGuid));

            // Determine updated alertData
            // If there are genuinely new alerts, prepend them; otherwise keep current data
            const updatedData = newData.length
                ? [...newData, ...currentPharmacyAlert.alertData]
                : currentPharmacyAlert.alertData;

            // // Filter out alerts in freshData that are already in topAlerts
            // const newData = data.results.filter((alert) => !topAlerts.some((oldAlert) => oldAlert.rxGuid === alert.rxGuid));

            // // If newData is empty, return current state unchanged
            // if (!newData.length) return currentPharmacyAlert;

            // // Add new alerts to the top of the CURRENT alertData
            // const updatedData = [...newData, ...currentPharmacyAlert.alertData];

            // This is not 100% accurate because if we received new data
            // and {page} is used for pagination,
            // we will end up skipping a few records.
            // But it's close enough
            return {
                ...currentPharmacyAlert,
                alertData: updatedData,
                cursor: currentPharmacyAlert.cursor,
                lastRefreshed: data.timeStamp,
                loading: false,
                error: false,
                alertCount: currentPharmacyAlert.alertCount,
                filteredCount: data.count,
                nextPage: currentPharmacyAlert.nextPage,
                isSorted: currentPharmacyAlert.isSorted,
            };
        });
    }


    const loadAlertsOnSort = async (sortField, sortDirection) => {
        var url = `${item.path}?sort=${sortField}&sortOrder=${sortDirection}&page=1`;

        if (selectedFacilities) {
            selectedFacilities.forEach((facility) => {
                url += `&facilityIds=${facility.facID}`;
            });
        }

        if (showResolved) {
            url += `&hideResolved=false`;
        }

        if (showAllFacilities) {
            url += `&showAll=true`;
        }

        if (searchValue) {
            url += `&searchValue=${encodeURIComponent(searchValue)}`;
        }

        let data = item.dummyData
            ? await fetchWidgetAlertsWithDummyFallback(url, item.dummyData)
            : (await SrxApi.get(url)).data;

        setPharmacyAlert((currentPharmacyAlert) => ({
            ...currentPharmacyAlert,
            alertData: data.results,
            cursor: data.cursor,
            lastRefreshed: data.timeStamp,
            loading: false,
            error: false,
            alertCount: currentPharmacyAlert.alertCount,
            filteredCount: data.count,
            nextPage: data.nextPage,
            isSorted: true,
        }));

        add100Rows();
    }

    const loadAlertsOnFilter = async () => {
        var facilities = selectedFacilities;

        var params = [];

        if (facilities) {
            facilities.forEach((facility) => {
                params.push(`facilityIds=${facility.facID}`);
            });
        }

        if (showResolved) {
            params.push('hideResolved=false');
        }

        if (pharmacyAlert.isSorted) {
            params.push(`sort=${sortBy.sortField}`, `sortOrder=${sortBy.sortDirection}`);
        }

        if (showAllFacilities) {
            params.push('showAll=true');
        }

        if (searchValue) {
            params.push(`searchValue=${encodeURIComponent(searchValue)}`);
        }

        var url = params.length ? `${item.path}?${params.join('&')}` : item.path;

        try {
            let data = item.dummyData
                ? await fetchWidgetAlertsWithDummyFallback(url, item.dummyData)
                : (await SrxApi.get(url)).data;

            // Ensure data exists and has the expected structure
            if (!data) {
                throw new Error('No data received from API');
            }

            setPharmacyAlert((currentPharmacyAlert) => ({
                ...currentPharmacyAlert,
                alertData: data.results || [],
                cursor: data.cursor || null,
                lastRefreshed: data.timeStamp || null,
                loading: false,
                error: false,
                alertCount: currentPharmacyAlert.alertCount,
                filteredCount: data.count || 0,
                nextPage: data.nextPage || null,
                isSorted: currentPharmacyAlert.isSorted,
            }));

            add100Rows();
        } catch (err) {
            console.error('Error loading alerts:', err);
            setPharmacyAlert((currentPharmacyAlert) => ({
                ...currentPharmacyAlert,
                loading: false,
                error: true,
                alertData: currentPharmacyAlert.alertData || [],
            }));
        }
    }

    function displayDifferenceInMinutes(rfrshTime) {
        const differenceInMinutes = Math.floor((new Date(currentTime).getTime() - new Date(rfrshTime).getTime()) / 60000);

        if (differenceInMinutes < 1) {
            return {
                minutes: differenceInMinutes,
                view: <small>Less than <span style={{ fontSize: '16px' }}><b>1</b></span> minute ago</small>
            };
        }

        if (differenceInMinutes === 1) {
            return {
                minutes: differenceInMinutes,
                view: <small><span style={{ fontSize: '16px' }}><b>{differenceInMinutes}</b></span> minute ago</small>
            };
        }

        if (differenceInMinutes <= 60) {
            return {
                minutes: differenceInMinutes,
                view: <small><span style={{ fontSize: '16px' }}><b>{differenceInMinutes}</b></span> minutes ago</small>
            };
        }

        return {
            minutes: differenceInMinutes,
            view: <small>More than <span style={{ fontSize: '16px' }}><b>1</b></span> hour ago</small>
        };
    }

    let differenceInMinutes = displayDifferenceInMinutes(pharmacyAlert.lastRefreshed);

    return (
        <Card hidden={hidden} style={{
            borderRadius: '11px', minHeight: '446.61px',
            opacity: !item.active ? '.30' : '',
            pointerEvents: !item.active ? 'none' : ''
        }}
        >
            <CardHeader
                className='d-flex align-items-center justify-content-center bg-primary text-white position-relative gradient-modal'
                style={{
                    borderTopLeftRadius: '11px', borderTopRightRadius: '11px',
                    background: "linear-gradient(90deg, #452f69 0%, #452f69 50%, #000 90%)"
                }}
            >
                <div className='position-relative d-flex justify-content-center align-items-center' style={{ maxWidth: 'max-content' }}>
                    <strong>{item.name.toLocaleUpperCase()}</strong>
                    {/* {item.active && <Badge className="position-absolute ml-1 d-flex justify-content-center align-items-center bg-danger
                                    print-all-badge"
                    style={{ visibility: 'hidden' }}
                    >
                        {(pharmacyAlert?.alertData?.length || 0) + ' of ' + (pharmacyAlert?.filteredCount || 0)}
                    </Badge>} */}
                    {item.active && (
                        <Badge style={{ height: 'fit-content', width: 'fit-content', textAlign: "center", padding: "0px 8px" }} color="danger" className="ml-2 d-flex justify-content-center align-items-center pt-1 pb-1">
                            {pharmacyAlert?.filteredCount ?? 0}
                        </Badge>
                    )}
                </div>

                {pharmacyAlert.lastRefreshed && <div className='position-absolute' style={{ left: '20px' }}>
                    <span className='elementToFadeInAndOut'><small>Updated</small></span>: {differenceInMinutes.view}
                </div>}

                <Button color="link" className='link-button p-0 d-flex align-items-center position-absolute hover-only refresh-widget-button-rotate'
                    style={{ right: '50px', color: 'white' }}
                    onClick={() => {
                        loadData(false);
                    }}
                    title="Refresh Alerts"
                >
                    <Icon icon={refreshIcon} width="25" />
                </Button>

                {/* TODO - display print option only for widgets that support it */}
                {item.listPrint &&
                    <Button
                        color="link"
                        className='link-button p-0 d-flex align-items-center position-absolute hover-only'
                        style={{ right: '80px', color: 'white' }}
                        title="Print PDF"
                        onClick={() => {
                            let doc = item["listPrintFunction"](pharmacyAlert.alertData, item.name);
                            window.open(doc.output('bloburl'), '_blank');
                        }}>
                        <Icon icon={printerIcon} width="25" />
                    </Button>
                }

                <Button color="link" className='link-button p-0 d-flex align-items-center position-absolute hover-only'
                    style={{ right: '20px', color: 'white' }}
                    onClick={() => routerHistory.push('/alerts/' + item.path)}
                    title="Open Widget"
                >
                    <Icon icon={arrowTopRightBoldBoxOutline} width="25" />
                </Button>
            </CardHeader>
            {pharmacyAlert.loading ?
                <div className='page-loading-loader-div w-100 d-flex justify-content-center align-items-center'>
                    <div>
                        {/* <h4>Loading alerts...</h4> */}
                        <div className="bouncing-loader">
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                </div>
                :
                <SimpleBar style={{ maxHeight: '400px' }}>
                    <CardBody className='pb-1 px-1 pt-0'>
                        <Table hover size='sm' className='mb-0'>
                            <thead style={{ position: 'sticky', top: '0', backgroundColor: 'white' }}>
                                <tr style={{ fontSize: '14px', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                                    {item.columns.map((col, index) => (
                                        <th key={index} className={`py-0 position-relative ${col.sort ? '' : 'noHover'}`} onClick={col.sort ? () => onClickSort(col.key) : null}
                                        >
                                            {col.icon && <Icon icon={col.icon} />} {col.name} {col.sort ? (sortBy.sortField === col.key) ? <SortCarets /> : <Icon icon={arrowsVertical} style={{ opacity: '0.6' }} /> : ''}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {pharmacyAlert.alertData?.length > 0 ?
                                    <>
                                        {pharmacyAlert.alertData.map((alert, index) =>
                                        (
                                            <tr key={index} style={{ fontSize: '13px' }}
                                                className={classNames(
                                                    { unreadRow: !alert.readByFaci },
                                                    { readRow: alert.readByFaci },
                                                    { resolvedRow: alert.srxStatus || alert.pharmacyStatus },
                                                    { newRow: alert.displayStatus === 'new' },
                                                    { oldRow: alert.displayStatus === 'old' },
                                                    { deletedRow: alert.displayStatus === 'deleted' },
                                                    { approvedRow: alert.displayStatus === 'approved' },
                                                    { approvedOnceRow: alert.displayStatus === 'approvedOnce' },
                                                    { deniedRow: alert.displayStatus === 'denied' },
                                                    { askedRow: alert.displayStatus === 'asked' },
                                                    { sendRow: alert.displayStatus?.toLowerCase() === 'send' },
                                                    { doNotSendRow: alert.displayStatus?.toLowerCase() === 'donotsend' }
                                                )}
                                                onClick={() => {
                                                    setActiveAlert({
                                                        name: item.name,
                                                        alert: alert,
                                                        stateName: item.stateName,
                                                        category: item.category,
                                                        requestActionPermissionWidgetName: item.requestActionPermissionWidgetName
                                                    });
                                                }}
                                            >
                                                {item.columns.map((col, index) => (
                                                    <td key={index} style={{ verticalAlign: 'middle' }} className={col?.className}>{col.prefix}{col.format ? col.format(alert[col.key], alert.rxGuid, alert) : alert[col.key]}{col.suffix}</td>
                                                ))}
                                            </tr>
                                        ))}
                                        <tr>
                                            <td colSpan="100%" align="center">
                                                {pharmacyAlert.alertData.length ?
                                                    pharmacyAlert.alertData.length < pharmacyAlert.filteredCount ? <Button color="link"
                                                        onClick={() => loadData()}>
                                                        <b>Show more...</b>
                                                    </Button>
                                                        :
                                                        <span><b>End of alerts</b></span>
                                                    :
                                                    <span><b>No alerts</b></span>
                                                }
                                            </td>
                                        </tr>
                                    </>
                                    :
                                    <tr>
                                        <td colSpan="6" align="center" style={{ fontSize: '30px', backgroundColor: 'white' }}>
                                            {/* <b>Coming Soon</b> */}
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </Table>
                    </CardBody>
                </SimpleBar>
            }
            {/* <Badge className="position-absolute ml-1 d-flex justify-content-center align-items-center bg-danger
                            print-all-badge"
                            >
                                { item.stateName === 'highCostAlerts'  && highCostAlerts.length }
                            </Badge> */}
        </Card>
    );
};

export default AlertsDashboard;